import { render } from "./Loading.vue?vue&type=template&id=a042d78c&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=a042d78c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a042d78c"

export default script